import { BehaviorSubject, Subject } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';

export abstract class BaseService {
  
  private processing = new BehaviorSubject<boolean>(false);
  processing$ = this.processing.asObservable();

  private errorMessage = new Subject<string>();
  errorMessage$ = this.errorMessage.asObservable();

  constructor(protected snackbar: MatSnackBar) { }

  setProcessing(processing: boolean) {
    this.processing.next(processing);
  }

  completeProcessing() {
    this.processing.complete();
  }

  setErrorMessage(errorMessage: string) {
    this.errorMessage.next(errorMessage);
  }

  setSnackbarMessage(snackbarMessage: string) {
    this.snackbar.open(snackbarMessage, 'DISMISS', { duration: 3000 });
  }
}
